import styled from 'styled-components'

import { Button } from '@/components'
import { Flex } from '@/components/Layout'
import { SelectFormField } from '@/components/UberForm'

const DIFF_BOTTOM_MARGIN = 32
const HEADER_GAP = 24
const LOADING_PADDING = 24
const SELECT_VERSION_MARGIN_LEFT = 10
const SELECT_VERSION_MIN_WIDTH = 130
const VERSION_SELECTS_GAP = 8
const VIEW_TOGGLE_MIN_WIDTH = 130

export const StyledDiffWrap = styled.div`
	flex: 1;
	min-height: 0;
	margin-bottom: ${DIFF_BOTTOM_MARGIN}px;
	overflow: auto;
	font-family: monospace;

	pre {
		white-space: pre-wrap;
	}
`

export const DiffHeaderFlex = styled(Flex)`
	align-items: center;
	gap: ${HEADER_GAP}px;
`

export const DiffViewToggleButton = styled(Button)`
	min-width: ${VIEW_TOGGLE_MIN_WIDTH}px;
`

export const LoadingPlaceholder = styled.div`
	padding: ${LOADING_PADDING}px;
	text-align: center;
`

export const DiffFooterActions = styled.div`
	display: flex;
	margin-left: auto;
	margin-top: auto;
`
export const StyledSelectVersion = styled(SelectFormField)`
	margin-left: ${SELECT_VERSION_MARGIN_LEFT}px;
	flex: 0 1;
	font-size: 14px;
	min-width: ${SELECT_VERSION_MIN_WIDTH}px;
`

export const VersionSelectsRow = styled.div<{ $splitView: boolean }>`
	display: flex;
	flex-direction: row;
	gap: ${VERSION_SELECTS_GAP}px;
	margin-bottom: ${VERSION_SELECTS_GAP}px;

	> *:first-child {
		flex: ${({ $splitView }) => ($splitView ? 1 : '0 1 auto')};
	}
	> *:last-child {
		flex: ${({ $splitView }) => ($splitView ? 1 : '0 1 auto')};
	}
`

